export enum EnumTagType {
  EnumTagTypeDefault,
  EnumTagTypeInvite,
  EnumTagTypeAudit,
  EnumTagTypeRule
}

export enum EnumTagMap {
  tags = EnumTagType.EnumTagTypeDefault,
  tagsInvite = EnumTagType.EnumTagTypeInvite,
  tagsAudit = EnumTagType.EnumTagTypeAudit,
  tagsRule = EnumTagType.EnumTagTypeRule
}

export enum EnumTagColor {
  tags = "#FFD580",
  tagsInvite = "#B0E57C",
  tagsAudit = "#FFC1C1",
  tagsRule = "#A7C7E7"
}
